import Menu from '@mui/material/Menu';
import React from 'react';
import { ReactChildren, SetState } from 'types/react';
import SidebarContextProvider from 'contexts/SidebarContext';
import { useSidebarContext } from 'hooks/sidebar';

export type SidebarItemType = "group" | "cascading" | "item"

export type SidebarItemProps = {
  type: SidebarItemType,
  key: string,
  ref?: string,
  children?: Array<SidebarItemProps>,
  label?: string,
  href?: string,
  icon?: string,
  activeIcon?: string
}

type SidebarMenuProps = {
  anchorEl: null | HTMLElement
  setAnchorEl: SetState<null | HTMLElement>,
  children: ReactChildren
  cascadingType: string
}

export default function SidebarMenu({children, anchorEl, setAnchorEl, cascadingType}: SidebarMenuProps){
  const { level, sidebarType, handleMenuClose } = useSidebarContext()

  const handleClose = () => {
    setAnchorEl(null);
    handleMenuClose()
  };

  const marginLeft = sidebarType == "menu" || level != 0
    ? '5px'
    : (cascadingType == 'menu' ? '40px' : '240px')

  return (
    <Menu
      id="sidebar-menu"
      anchorEl={anchorEl}
      MenuListProps={{onMouseLeave:handleClose}}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      sx={{ zIndex: 1000, marginLeft }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: sidebarType == "menu" || level > 0 ? 'right' : 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <SidebarContextProvider sidebarType={"menu"} addLevel handleMenuClose={handleClose}>
        {children}
      </SidebarContextProvider>
    </Menu>
  );
}

